define('views/pages/basket/basket-item',['require','jquery','underscore','chaplin','models/base/model','views/base/view','text!templates/pages/basket/basket-item.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        Chaplin = require('chaplin'),
        Model = require('models/base/model'),
        View = require('views/base/view'),
        template = require('text!templates/pages/basket/basket-item.ejs');

    var BasketItemView = View.extend({
        template: template,
        className: 'basket-item',
        tagName: 'tr',
        listen: {
            'change:comment model': 'render',
            'change:amount model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', '.table-basket-delete .btn', this.deleteClick);
        },
        render: function () {
            this.destroyTooltip();

            View.prototype.render.apply(this, arguments);

            this.$('.table-basket-comment i').tooltip({ container: 'body', placement: 'bottom' });
        },
        deleteClick: function(){
            this.model.destroy();
        },
        dispose: function() {
            if (this.disposed) { return; }

            this.destroyTooltip();

            View.prototype.dispose.apply(this, arguments);
        },

        destroyTooltip: function() {
            this.$('.table-basket-comment i').tooltip('destroy');
        }
    });

    return BasketItemView;
});

